import { SvgIcon } from "@mui/material"

const PropDetailsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" viewBox="0 0 20 22">
      <path
        d="M10.005 2.86303L18.0957 9.0792V19.7182H1.91436V9.0792L10.005 2.86303ZM10.005 0.445068L0 8.14224V21.6425H20V8.14224L10.005 0.445068Z"
        fill="inherit"
      />
      <mask id="mask0_348_993" maskUnits="userSpaceOnUse" x="1" y="5" width="17" height="16">
        <rect x="1.97656" y="5.28076" width="15.055" height="15.3152" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_348_993)">
        <path
          d="M3.8584 18.6814V9.7476H6.36756V7.19507H12.6405V12.3001H15.1496V18.6814H10.1313V16.1289H8.87672V18.6814H3.8584ZM5.11298 17.4052H6.36756V16.1289H5.11298V17.4052ZM5.11298 14.8526H6.36756V13.5764H5.11298V14.8526ZM5.11298 12.3001H6.36756V11.0239H5.11298V12.3001ZM7.62214 14.8526H8.87672V13.5764H7.62214V14.8526ZM7.62214 12.3001H8.87672V11.0239H7.62214V12.3001ZM7.62214 9.7476H8.87672V8.47133H7.62214V9.7476ZM10.1313 14.8526H11.3859V13.5764H10.1313V14.8526ZM10.1313 12.3001H11.3859V11.0239H10.1313V12.3001ZM10.1313 9.7476H11.3859V8.47133H10.1313V9.7476ZM12.6405 17.4052H13.895V16.1289H12.6405V17.4052ZM12.6405 14.8526H13.895V13.5764H12.6405V14.8526Z"
          fill="inherit"
        />
      </g>
      <defs>
        <linearGradient id="paint0_linear_348_993" x1="20" y1="11.2068" x2="1.5785e-07" y2="11.2068" gradientUnits="userSpaceOnUse">
          <stop stopColor="#58CA04" />
          <stop offset="1" stopColor="#8DDB53" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PropDetailsIcon
